import React, { useCallback } from 'react';
import { useLocation, useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import ProcesosPeriodosModal, {
  type ProfasePeriodoRow,
  type PeriodoVista,
  parsePeriodoVista,
} from './ProcesosPeriodosModal';
import { applyPeriodoFilterToParams } from './procesos-periodo-utils';

export interface ProcesosOutletContext {
  refreshAfterPeriodoChange?: () => void;
}

interface ProcesosPeriodoLocationState {
  procesosSearch?: string;
}

function readProcesosReturnSearch(location: ReturnType<typeof useLocation>): string {
  return (location.state as ProcesosPeriodoLocationState | null)?.procesosSearch ?? '';
}

export default function ProcesosPeriodoModalRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { refreshAfterPeriodoChange } = useOutletContext<ProcesosOutletContext>();

  const estadoVista = parsePeriodoVista(searchParams.get('estado'));
  const procesosReturnSearch = readProcesosReturnSearch(location);

  const handleClose = useCallback(() => {
    navigate(`/procesos${procesosReturnSearch}`);
  }, [navigate, procesosReturnSearch]);

  const handleEstadoVistaChange = useCallback((vista: PeriodoVista) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.set('estado', vista);
      return next;
    }, { replace: true });
  }, [setSearchParams]);

  const handleSelectPeriodo = useCallback((periodo: ProfasePeriodoRow) => {
    const params = new URLSearchParams(
      procesosReturnSearch.startsWith('?')
        ? procesosReturnSearch.slice(1)
        : procesosReturnSearch,
    );
    if (!applyPeriodoFilterToParams(params, periodo)) return;
    navigate(`/procesos?${params.toString()}`);
  }, [navigate, procesosReturnSearch]);

  return (
    <ProcesosPeriodosModal
      open
      estadoVista={estadoVista}
      onEstadoVistaChange={handleEstadoVistaChange}
      onClose={handleClose}
      onSelectPeriodo={handleSelectPeriodo}
      onArchivadoChange={refreshAfterPeriodoChange}
    />
  );
}
